/* eslint-disable @next/next/no-img-element */
import { useState, useEffect } from "react";

// next.js components
import Link from "next/link";

// react-jsx-parser components
import JsxParser from "react-jsx-parser";

// @material-tailwind/react components
import { Typography, Button } from "@material-tailwind/react";

// page components
import CodePreview from "components/cards/code-preview";

export default function SectionButton() {
  const [buttonType, setButtonType] = useState("icon");
  const [buttonCode, setButtonCode] = useState(null);

  useEffect(() => {
    switch (buttonType) {
      case "default":
        setButtonCode(`
        
        
        
<Button>Button</Button>`);
        break;
      case "gradient":
        setButtonCode(`
        
        
<Button variant="gradient">
  Button
</Button>`);
        break;
      case "link":
        setButtonCode(`
        

<Button variant="text">
  Button
</Button>`);
        break;
      case "icon":
        setButtonCode(`#include <iostream>
using namespace std;

int main() {
  int age;
  cout << "Enter your age: ";
  cin >> age;

  if (age >= 18) {
    cout << "Above 18" << endl;
  } 
  else {
    cout << "Under 18" << endl;
  }

  return 0;
}`);
        break;
    }
  }, [buttonType]);

  const buttonOptionClasses = (type) => `
    cursor-pointer select-none transition-all duration-300 ${
      buttonType === type ? "opacity-100" : "opacity-60"
    }
  `;

  return (
    <section className="py-24">
      <div className="flex flex-wrap items-center">
        <div className="w-full px-4 lg:w-5/12">
          <Typography
            variant="h2"
            className="mb-2 font-black tracking-normal text-[#1A237E]"
          >
            Change your <br />
            <Typography
              as="span"
              variant="h2"
              color="blue"
              className="inline-block font-black tracking-normal"
              textGradient
            >
              Future
            </Typography>{" "}
            With us.
          </Typography>
          <Typography className="mb-5 text-lg text-[#1A237E]/60 md:pr-10">
            Originally designed for systems programming, C++ offers fine control
            over hardware resources and is often used in performance-critical
            applications, game development, and operating systems.
          </Typography>
          <Link href="/docs/react/button">
            <Button>Get Started</Button>
          </Link>
        </div>
        <div className="relative mt-10 w-full px-4 md:w-8/12 lg:mt-0 lg:w-6/12">
          <CodePreview
            code={`${buttonCode}
`}
          />
        </div>
      </div>
    </section>
  );
}
